import { Image } from '@com-delta-idp/mnx-ui-kit';
import {
  AnalyticsEvent,
  GenericLabel
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Actions, DisplayProperties } from '../../../models';
export interface Slide {
  desktopImage: Image;
  mobileImage: Image;
  content: GenericLabel;
}

export enum SCREEN_VIEW {
  MOBILE = 414
}

export interface WelcomeTour extends DisplayProperties {
  slides: Slide[];
  header: string;
  analyticsEvent: AnalyticsEvent;
  ariaLabels: WelcomeTourAriaLabels;
}

export interface WelcomeTourAriaLabels {
  close: string;
  action: Actions;
}
